import Axios from "axios";
import {
    SET_INVENTORY_RECORDS_LIST,
    UNSET_INVENTORY_RECORDS_LIST,
  } from "@/store/mutation-types";
import { getInventoryRecordsList, getInventoryRecordDetails } from "@/store/api";

// initial state
const state = {
  inventoryRecordsList: [],
};

const getters = {
  getInventoryRecordsList(state) {
    return state.inventoryRecordsList;
  }
};

const mutations = {
  [SET_INVENTORY_RECORDS_LIST](state, data) {
    state.inventoryRecordsList = data;
  },
  [UNSET_INVENTORY_RECORDS_LIST](state) {
    state.inventoryRecordsList = [];
  }
};

const actions = {
  getInventoryRecordsList({ commit }, params) {
    return new Promise((resolve, reject) => {
      Axios.get(getInventoryRecordsList, { params })
        .then(function (response) {
          commit('SET_INVENTORY_RECORDS_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_INVENTORY_RECORDS_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getInventoryRecordDetails({ commit }, id) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getInventoryRecordDetails}/${id}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

